export default __webpack_public_path__ + "static/media/chrome-logo.56c8edbc.svg";